import PeriodSelector from "components/PeriodSelector";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import { t } from "i18next";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useIconStyles = makeThemedStyles("CascadeToolbarIcon", (theme) => ({
  root: {
    marginLeft: 0,
    marginRight: "15px",
    marginTop: 0,
    width: "50px",
    height: "50px",
    backgroundImage: `url(${getFileApiURL(`/icons/navitems/cascade.svg`)})`,
  },
}));

const CascadeToolbar = () => {
  const iconstyles = useIconStyles();
  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>
          <span className={iconstyles.root}></span>
          {t("cascade.Cascade Strategy")}
        </ToolbarTitle>
        <Right>
          <PeriodSelector />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default CascadeToolbar;
